import { LoyaltyMenuState, TGiftItem } from "../../types";

export const updateMenuItems = (
  state: LoyaltyMenuState,
  item: TGiftItem
): LoyaltyMenuState => {
  const category = state.shownCategoriesById[item.category_id];
  if (!category) return state;

  const updatedItems = category.items.filter((i) => i.id !== item.id);
  const isLastItem = updatedItems.length === 0;
  const shownCategoriesIds = isLastItem
    ? state.shownCategoriesIds.filter((id) => id !== item.category_id)
    : state.shownCategoriesIds;
  const shownCategoriesById = isLastItem
    ? Object.fromEntries(
        Object.entries(state.shownCategoriesById).filter(
          ([id]) => id !== item.category_id
        )
      )
    : {
        ...state.shownCategoriesById,
        [item.category_id]: {
          ...category,
          items: updatedItems,
        },
      };

  return {
    ...state,
    shownCategoriesIds,
    shownCategoriesById,
  };
};
